export const omniProductLevelOptions = [
    { display: 'Brand', value: 'brand' },
    { display: 'Brand Family', value: 'brandFamily' },
    { display: 'Brand Low', value: 'brandLow' },
    { display: 'Manufacturer', value: 'manufacturer' },
];